export type ConversationTimelineItem = {
    id: string;
    kind: 'lead' | 'message' | 'outbound';
    role: 'user' | 'assistant' | 'system';
    content: string;
    status: string | null;
    createdAt: string;
};

export function normalizeConversationTimeline(value: unknown): ConversationTimelineItem[] {
    if (!Array.isArray(value)) throw new Error('Неверный ответ истории диалога');
    const seen = new Set<string>();
    return value
        .map((item): ConversationTimelineItem => {
            if (
                !item ||
                typeof item.id !== 'string' ||
                !item.id ||
                seen.has(item.id) ||
                !['lead', 'message', 'outbound'].includes(item.kind) ||
                !['user', 'assistant', 'system'].includes(item.role) ||
                (item.kind === 'outbound' && item.role !== 'assistant') ||
                typeof item.content !== 'string' ||
                typeof item.created_at !== 'string' ||
                !Number.isFinite(Date.parse(item.created_at)) ||
                (item.status != null && typeof item.status !== 'string')
            ) {
                throw new Error('Неверный ответ истории диалога');
            }
            seen.add(item.id);
            return {
                id: item.id,
                kind: item.kind,
                role: item.role,
                content: item.content,
                status: item.status || null,
                createdAt: item.created_at,
            };
        })
        .sort((left, right) => Date.parse(left.createdAt) - Date.parse(right.createdAt));
}
